import { Toast as AnvilToast } from '@servicetitan/design-system';
import ToastModule from '..';
import { useEffect } from 'react';

type ToastProps = React.ComponentProps<typeof AnvilToast> & {
  key: string;
  createdAt: number;
  toastBody?: string;
};

const Toast = ({ createdAt, toastBody, ...props }: ToastProps) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      // remove the toast
      ToastModule.hideToast(createdAt);
    }, props.duration);

    return () => {
      clearTimeout(timeout);
    };
  }, [createdAt, props.duration]);

  const handleClose = () => {
    props.onClose?.();
    ToastModule.hideToast(createdAt);
  };

  return (
    <AnvilToast {...props} onClose={handleClose}>
      {toastBody}
    </AnvilToast>
  );
};

export default Toast;
